import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { localeFromPath, localizedPath } from "../lib/locale";

const PUBLIC_PREFIXES = ["/", "/login", "/signup", "/platforms", "/blog", "/calculator", "/referral", "/terms", "/privacy", "/refund", "/contact", "/solutions"];

function isLocalizable(pathname) {
    if (pathname === "/") return true;
    return PUBLIC_PREFIXES.some((p) => p !== "/" && (pathname === p || pathname.startsWith(`${p}/`)));
}

// Keeps URL and content language consistent: a non-English user on an unprefixed public URL is moved to /xx/...
export default function LocaleRedirect() {
    const { language } = useLanguage();
    const { pathname, search, hash } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!language || language === "en" || localeFromPath(pathname) || !isLocalizable(pathname)) return;
        navigate(`${localizedPath(language, pathname)}${search}${hash}`, { replace: true });
    }, [language, pathname, search, hash, navigate]);

    return null;
}
